import { GatsbyImage, getImage, IGatsbyImageData } from "gatsby-plugin-image";
import * as React from "react";

import { Post } from "../../../../contexts/blog/domain/post";
import DoNotMountComponent from "../../../../modules/DoNotMountComponent/DoNotMountComponent";
import Markdown from "../../../../modules/Markdown/Markdown";
import Share from "../../Share/Share";

const AuthorResume: React.FC<{ post: Post }> = (props: { post: Post }) => {
  const { post } = props;
  if (!post) return <DoNotMountComponent sms={"No existen post"} log={props} />;
  // console.log(
  //   "este es la bio2",
  //   author.authors[0].biography[0].children[0].text
  // );
  return (
    <div className="o-author-resume">
      <div className="m-author-resume">
        <div
          className={`m-author-resume__img m-author-resume__img--${post?.color}`}
        >
          {post.authors[0].summary?.photo?.asset && (
            <GatsbyImage
              imgClassName={"a-post-img"}
              objectFit={"contain"}
              alt={`Portada del autor`}
              image={
                getImage(
                  post.authors[0].summary.photo.asset.gatsbyImageData,
                ) as IGatsbyImageData
              }
            />
          )}
        </div>
        <div className={"m-resume__body"}>
          {/*<span className={`button-tag button-tag--${post?.color}`}>*/}
          {/*  {post.authors[0].name}*/}
          {/*</span>*/}
          <Markdown markdown={post.authors[0].summary?.text} />
          {/*<p className="text">*/}
          {/*  {author.authors[0].biography &&*/}
          {/*  author.authors[0].biography[0].children[0].text*/}
          {/*    ? author.authors[0].biography[0].children[0].text*/}
          {/*    : "Trabajé en The Cookies"}*/}
          {/*</p>*/}
          <Share
            toShare={{
              title: post.title,
              socials: {
                linkedin: post.authors[0].socials.linkedin,
                twitter: post.authors[0].socials.twitter,
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AuthorResume;
